import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Thalia admin module — `/thalia` on console.francisquini.ai.
 *
 * Multi-brand AI content service surface. Lazy-loaded via the
 * `@/routes/_app/thalia` Suspense shim, same as before T9.7.
 */
export const manifest: ModuleManifest = {
  module_id: 'thalia',
  display_name: 'Thalia',
  surface: 'admin',
  routes: [
    {
      path: '/thalia',
      component: () =>
        import('@/routes/_app/thalia').then((m) => ({
          default: m.ThaliaPage,
        })),
      title: 'Thalia',
      permissions: [],
    },
  ],
}
